import { DRUPAL_NODE_DISPLAY, type DrupalLink, type DrupalNode } from '@commons/types/drupal';

import PressReleaseNodeCard from './Card';
import PressReleaseNodeLabel from './Label';

/**
 * Type definition of a PressRelease node properties.
 */

export type PressReleaseNodeProps = DrupalNode & {
  date: string;
  link: DrupalLink;
  description: string;
};

/**
 * PressRelease node component.
 *
 * Renders a component based on the display type.
 */

export const PressReleaseNode = (props: PressReleaseNodeProps) => {
  switch (props.display) {
    default:
    case DRUPAL_NODE_DISPLAY.Default:
    case DRUPAL_NODE_DISPLAY.Label:
      return <PressReleaseNodeLabel {...props} />;
    case DRUPAL_NODE_DISPLAY.Teaser:
    case DRUPAL_NODE_DISPLAY.Card:
    case DRUPAL_NODE_DISPLAY.Featured:
      return <PressReleaseNodeCard {...props} />;
  }
};

export default PressReleaseNode;
